/* =====================================================================
   The Italian Chocolate 1971 · header: language switcher + cart count     v1.1 · 2026-10-15
   Loaded once by snippets/tic-lang-switcher.liquid (context 'header'), defer. No dependencies.

   1. Language switcher ([data-tic-lang], header + mobile menu drawer)
      - Translation stays with the GTranslate app (url_structure "none"): switching calls the app's
        global doGTranslate('en|<lang>'), exactly what its own widget links do. 'en|en' restores the
        original page. Verified on the draft: <html lang> changes ~100 ms after the call, the text
        ~250 ms after; the choice persists in localStorage __GT_TRANSLATE_LANGS.
        If doGTranslate is missing (app script still loading or blocked) the choice is written to
        localStorage and the page reloads: the app reads it on load.
      - Current language: localStorage __GT_TRANSLATE_LANGS.tgtLang, then <html lang>, then the
        app's default. Followed live (MutationObserver on <html lang> + the storage event).
      - Menu button pattern: button[aria-haspopup=menu][aria-expanded] + role=menu with
        menuitemradio[aria-checked]. Enter/Space/ArrowDown open on the current language, ArrowUp
        on the last item; in the menu ArrowUp/Down wrap, Home/End, type-ahead (reset on every open),
        Esc closes and returns focus, Tab closes. Click outside closes; a resize closes it only when the
        width changes (not when a phone's toolbar shows or hides). Opened from the keyboard the menu appears at once
        (no animation after a keyboard action); opened by pointer it scales in from the trigger.
      - Languages beyond the six printed in Liquid come from window.gtranslateSettings, under
        "More languages" (expanded automatically when the current language is one of them).
   2. Cart count bubble (#cart-icon-bubble, theme icon mode)
      - data-tic-count on the link (set here; before that the snippet's empty-cart style): CSS hides the bubble at 0.
      - The link's accessible name follows the count: "Open cart, 2 items" (the theme's aria-label
        "Open cart" alone hid the count from screen readers).
      - The theme re-renders the bubble after every add/change (section rendering API). When the
        number changes, the new bubble (0 -> n) or the new number (n -> m) enters with the better-ui
        icon recipe (opacity 0 -> 1, scale 0.25 -> 1, blur 4px -> 0, 300 ms, cubic-bezier(0.2, 0, 0, 1)).
   3. Letter-split header labels and Google translation
      - The theme splits the top-level menu links and the country button into one <span> per letter
        (its letter-roll hover). Google then translates letter by letter: in German every "I" becomes
        "Ich" ("TASTICHNG ICHN FLORENCE", "ICHTALY/€", seen on the draft). The roll is already off on
        the top-level links (tic-site-chrome.css 2.2), so their letters are joined back into one text
        node and the phrase is translated whole, like the mobile menu. The country button keeps its
        roll and is marked notranslate (a country/currency label, like the code "EN"). So is the
        burger's "Menu" label (tablet widths, fit level 3): Google turns it into "Speisekarte".
   4. Header fit (desktop): translated menus are longer; the header steps down (tighter spacing, then
      no country selector in the row, then the theme's "Menu" button) only as far as the text needs,
      so country, language and cart never leave the screen. Levels: [data-tic-fit] in tic-header.css.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__ticHeader) return;
  window.__ticHeader = true;

  var doc = document;
  var root = doc.documentElement;
  var LS = '__GT_TRANSLATE_LANGS';

  /* ------------------------------------------------------------------
     1. Language switcher
     ------------------------------------------------------------------ */
  // Native names (lang_array_native of GTranslate, shortened where it adds the word "language")
  var NAMES = {
    en: 'English', it: 'Italiano', de: 'Deutsch', fr: 'Français', es: 'Español', nl: 'Nederlands',
    bg: 'Български', hr: 'Hrvatski', cs: 'Čeština', da: 'Dansk', et: 'Eesti', fi: 'Suomi', el: 'Ελληνικά',
    hu: 'Magyar', ga: 'Gaeilge', lv: 'Latviešu', lt: 'Lietuvių', lb: 'Lëtzebuergesch', mt: 'Malti',
    pl: 'Polski', pt: 'Português', ro: 'Română', sk: 'Slovenčina', sl: 'Slovenščina', sv: 'Svenska',
    no: 'Norsk', is: 'Íslenska', ca: 'Català', eu: 'Euskara', gl: 'Galego', cy: 'Cymraeg', sq: 'Shqip',
    sr: 'Српски', mk: 'Македонски', uk: 'Українська', ru: 'Русский', tr: 'Türkçe', ja: '日本語',
    ko: '한국어', 'zh-CN': '简体中文', 'zh-TW': '繁體中文', ar: 'العربية', iw: 'עברית', hi: 'हिन्दी'
  };

  function appSettings() {
    var all = window.gtranslateSettings;
    if (!all || typeof all !== 'object') return null;
    if (all.default_language) return all;
    for (var k in all) {
      if (all[k] && all[k].default_language) return all[k];
    }
    return null;
  }

  var cfg = appSettings();
  var DEF = (cfg && cfg.default_language) || 'en';
  var LANGS = (cfg && Array.isArray(cfg.languages) && cfg.languages.length) ? cfg.languages.slice() : null;
  var pending = null; // language chosen here, until <html lang> confirms it
  var pendingTimer = 0;

  function known(l) {
    if (!l) return null;
    if (!LANGS) return NAMES[l] ? l : null;
    if (LANGS.indexOf(l) > -1) return l;
    var two = l.slice(0, 2).toLowerCase();
    return LANGS.indexOf(two) > -1 ? two : null;
  }
  function stored() {
    try {
      var v = JSON.parse(localStorage.getItem(LS) || 'null');
      return v && typeof v.tgtLang === 'string' ? v.tgtLang : null;
    } catch (e) {
      return null;
    }
  }
  function current() {
    return known(pending) || known(stored()) || known(root.getAttribute('lang')) || DEF;
  }
  function nameOf(l) {
    return NAMES[l] || l.toUpperCase();
  }

  var instances = [];
  var openInst = null;

  function items(inst) {
    // visible menu items, in order (the "More" group only when expanded)
    return Array.prototype.filter.call(inst.menu.querySelectorAll('[role^="menuitem"]'), function (el) {
      return !el.hidden && !el.closest('[hidden]');
    });
  }

  function makeItem(code) {
    var b = doc.createElement('button');
    b.type = 'button';
    b.className = 'tic-lang__item notranslate';
    b.setAttribute('translate', 'no');
    b.setAttribute('role', 'menuitemradio');
    b.setAttribute('aria-checked', 'false');
    b.setAttribute('tabindex', '-1');
    b.setAttribute('lang', code);
    b.setAttribute('data-lang', code);
    b.innerHTML =
      '<svg class="tic-lang__check" aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 8.5l3 3 6-7"/></svg>' +
      '<span class="tic-lang__item-name"></span><span class="tic-lang__item-code" aria-hidden="true"></span>';
    b.querySelector('.tic-lang__item-name').textContent = nameOf(code);
    b.querySelector('.tic-lang__item-code').textContent = code.toUpperCase();
    return b;
  }

  function build(el) {
    var inst = {
      el: el,
      trigger: el.querySelector('[data-tic-lang-trigger]'),
      menu: el.querySelector('[data-tic-lang-menu]'),
      scroll: el.querySelector('.tic-lang__scroll'),
      more: el.querySelector('[data-tic-lang-more]'),
      group: el.querySelector('[data-tic-lang-group]'),
      isDrawer: el.classList.contains('tic-lang--drawer')
    };
    if (!inst.trigger || !inst.menu) return null;

    // Keep the printed languages the app offers; add the others under "More languages".
    if (LANGS) {
      Array.prototype.forEach.call(inst.menu.querySelectorAll('[data-lang]'), function (b) {
        if (LANGS.indexOf(b.getAttribute('data-lang')) < 0) b.remove();
      });
      var printed = {};
      Array.prototype.forEach.call(inst.menu.querySelectorAll('[data-lang]'), function (b) {
        printed[b.getAttribute('data-lang')] = true;
      });
      var extra = LANGS.filter(function (l) { return !printed[l]; });
      var collator = window.Intl && Intl.Collator ? new Intl.Collator('en') : null;
      extra.sort(function (a, b) {
        return collator ? collator.compare(nameOf(a), nameOf(b)) : (nameOf(a) < nameOf(b) ? -1 : 1);
      });
      if (extra.length && inst.more && inst.group) {
        extra.forEach(function (l) { inst.group.appendChild(makeItem(l)); });
        Array.prototype.forEach.call(el.querySelectorAll('[data-tic-lang-extra]'), function (x) { x.hidden = false; });
      }
    }
    instances.push(inst);
    wire(inst);
    return inst;
  }

  function render(lang) {
    var code = lang.toUpperCase();
    var name = nameOf(lang);
    instances.forEach(function (inst) {
      var c = inst.el.querySelector('[data-tic-lang-code]');
      var n = inst.el.querySelector('[data-tic-lang-name]');
      if (c && c.textContent !== code) c.textContent = code;
      if (n && n.textContent !== name) n.textContent = name;
      inst.trigger.setAttribute('aria-label', 'Language: ' + name);
      Array.prototype.forEach.call(inst.menu.querySelectorAll('[data-lang]'), function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-lang') === lang ? 'true' : 'false');
      });
    });
  }

  function setMore(inst, expanded) {
    if (!inst.more || !inst.group || inst.more.hidden) return;
    inst.more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    inst.group.hidden = !expanded;
  }

  function nextFrame(fn) {
    requestAnimationFrame(function () { requestAnimationFrame(fn); });
  }

  function open(inst, opts) {
    if (openInst && openInst !== inst) close(openInst, { instant: true });
    resetType();
    var lang = current();
    var inGroup = inst.group && inst.group.querySelector('[data-lang="' + lang + '"]');
    setMore(inst, !!inGroup);
    if (opts.instant) inst.el.setAttribute('data-instant', '');
    inst.el.setAttribute('data-open', '');
    inst.trigger.setAttribute('aria-expanded', 'true');
    openInst = inst;
    inst.scrollY = window.scrollY;
    var list = items(inst);
    var target = opts.focus === 'last' ? list[list.length - 1]
      : opts.focus === 'first' ? list[0]
      : inst.menu.querySelector('[data-lang="' + lang + '"]') || list[0];
    if (target) {
      target.focus({ preventScroll: true });
      keepVisible(inst, target);
    }
    if (opts.instant) nextFrame(function () { inst.el.removeAttribute('data-instant'); });
  }

  function close(inst, opts) {
    if (!inst || openInst !== inst) return;
    opts = opts || {};
    if (opts.instant) inst.el.setAttribute('data-instant', '');
    inst.el.removeAttribute('data-open');
    inst.trigger.setAttribute('aria-expanded', 'false');
    openInst = null;
    resetType();
    if (opts.focus) inst.trigger.focus({ preventScroll: true });
    if (opts.instant) nextFrame(function () { inst.el.removeAttribute('data-instant'); });
  }

  function keepVisible(inst, el) {
    var box = inst.scroll;
    if (!box || box.scrollHeight <= box.clientHeight) return;
    var top = el.offsetTop - box.offsetTop;
    if (top < box.scrollTop) box.scrollTop = top - 4;
    else if (top + el.offsetHeight > box.scrollTop + box.clientHeight) box.scrollTop = top + el.offsetHeight - box.clientHeight + 4;
  }

  function focusItem(inst, el) {
    if (!el) return;
    el.focus({ preventScroll: true });
    keepVisible(inst, el);
  }

  function choose(inst, lang) {
    close(inst, { focus: true });
    if (lang === current()) return;
    pending = lang;
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () { pending = null; render(current()); }, 4000);
    render(lang);
    instances.forEach(function (i) {
      var c = i.el.querySelector('[data-tic-lang-code]');
      if (!c) return;
      c.classList.remove('tic-lang__swap');
      void c.offsetWidth;
      c.classList.add('tic-lang__swap');
    });
    if (typeof window.doGTranslate === 'function') {
      window.doGTranslate(DEF + '|' + lang);
    } else {
      try {
        if (lang === DEF) localStorage.removeItem(LS);
        else localStorage.setItem(LS, JSON.stringify({ srcLang: DEF, tgtLang: lang }));
      } catch (e) { /* storage blocked: nothing else to do */ }
      location.reload();
    }
  }

  var typeBuf = '';
  var typeTimer = 0;
  // a new menu starts a new search ("d", Esc, reopen, "d" must find Deutsch, not "dd")
  function resetType() {
    clearTimeout(typeTimer);
    typeBuf = '';
  }

  function wire(inst) {
    inst.trigger.addEventListener('click', function (e) {
      if (openInst === inst) close(inst, { focus: e.detail === 0 });
      else open(inst, { instant: e.detail === 0, focus: 'current' });
    });
    inst.trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (openInst !== inst) open(inst, { instant: true, focus: e.key === 'ArrowUp' ? 'last' : 'current' });
      }
    });

    inst.menu.addEventListener('click', function (e) {
      var item = e.target.closest('[role^="menuitem"]');
      if (!item || !inst.menu.contains(item)) return;
      if (item === inst.more) {
        var expand = inst.more.getAttribute('aria-expanded') !== 'true';
        setMore(inst, expand);
        if (expand) {
          var first = inst.group.querySelector('[role^="menuitem"]');
          if (e.detail === 0) focusItem(inst, first);
          else if (inst.scroll) inst.scroll.scrollTop = inst.more.offsetTop - inst.scroll.offsetTop - 4;
          if (e.detail !== 0) {
            inst.group.classList.remove('tic-lang__group--in');
            void inst.group.offsetWidth;
            inst.group.classList.add('tic-lang__group--in');
          }
        }
        return;
      }
      var lang = item.getAttribute('data-lang');
      if (lang) choose(inst, lang);
    });

    // clicks on the popover padding must not move focus out of the menu
    inst.menu.addEventListener('pointerdown', function (e) {
      if (!e.target.closest('[role^="menuitem"]')) e.preventDefault();
    });

    inst.menu.addEventListener('keydown', function (e) {
      var list = items(inst);
      var i = list.indexOf(doc.activeElement);
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          focusItem(inst, list[(i + 1) % list.length]);
          break;
        case 'ArrowUp':
          e.preventDefault();
          focusItem(inst, list[(i - 1 + list.length) % list.length]);
          break;
        case 'Home':
        case 'PageUp':
          e.preventDefault();
          focusItem(inst, list[0]);
          break;
        case 'End':
        case 'PageDown':
          e.preventDefault();
          focusItem(inst, list[list.length - 1]);
          break;
        case 'ArrowRight':
          if (doc.activeElement === inst.more && inst.more.getAttribute('aria-expanded') !== 'true') {
            e.preventDefault();
            inst.more.click();
          }
          break;
        case 'ArrowLeft':
          if (inst.group && inst.group.contains(doc.activeElement)) {
            e.preventDefault();
            setMore(inst, false);
            focusItem(inst, inst.more);
          }
          break;
        case 'Escape':
          e.preventDefault();
          e.stopPropagation(); // the mobile drawer closes on Escape too: only the menu closes here
          inst.escaped = true;
          close(inst, { focus: true });
          break;
        case 'Tab':
          close(inst, { instant: true });
          break;
        default:
          if (e.key.length === 1 && /\S/.test(e.key) && !e.ctrlKey && !e.metaKey && !e.altKey) {
            clearTimeout(typeTimer);
            typeBuf += e.key.toLowerCase();
            typeTimer = setTimeout(function () { typeBuf = ''; }, 600);
            var start = typeBuf.length === 1 ? i + 1 : i;
            for (var k = 0; k < list.length; k++) {
              var cand = list[(start + k) % list.length];
              var label = (cand.querySelector('.tic-lang__item-name') || cand).textContent.trim().toLowerCase();
              var code = (cand.getAttribute('data-lang') || '').toLowerCase();
              if (label.indexOf(typeBuf) === 0 || code === typeBuf) { focusItem(inst, cand); break; }
            }
          }
      }
    });

    // swallow the keyup of the Escape that closed the menu (theme drawers close on keyup Escape)
    inst.el.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && inst.escaped) {
        e.stopPropagation();
        inst.escaped = false;
      }
    });

    inst.el.addEventListener('focusout', function (e) {
      if (openInst === inst && e.relatedTarget && !inst.el.contains(e.relatedTarget)) close(inst, { instant: true });
    });
  }

  doc.addEventListener('pointerdown', function (e) {
    if (openInst && !openInst.el.contains(e.target)) close(openInst);
  }, true);

  // the header hides on scroll down (theme sticky "on-scroll-up"): the menu goes with it
  window.addEventListener('scroll', function () {
    if (openInst && !openInst.isDrawer && Math.abs(window.scrollY - openInst.scrollY) > 48) close(openInst);
  }, { passive: true });
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    var w = window.innerWidth;
    if (w === lastW) return; // phone toolbar showing / hiding: height only, the menu stays put
    lastW = w;
    if (openInst) close(openInst, { instant: true });
  });

  function initLang() {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-tic-lang]'), function (el) {
      if (!el.__ticLang) {
        el.__ticLang = true;
        build(el);
      }
    });
    render(current());
  }

  // follow the page language, whoever changes it (this menu, another tab, the app on load)
  new MutationObserver(function () {
    var l = known(root.getAttribute('lang'));
    if (pending && l === pending) {
      pending = null;
      clearTimeout(pendingTimer);
    }
    render(current());
  }).observe(root, { attributes: true, attributeFilter: ['lang'] });
  window.addEventListener('storage', function (e) {
    if (e.key === LS || e.key === null) render(current());
  });

  // theme editor: the header section can be re-rendered
  doc.addEventListener('shopify:section:load', function () {
    instances = instances.filter(function (i) { return doc.contains(i.el); });
    initLabels();
    initLang();
    initCart();
  });

  /* ------------------------------------------------------------------
     2. Cart count bubble
     ------------------------------------------------------------------ */
  var cartObserver = null;

  function readCount(link) {
    var s = link.querySelector('.cart-count-bubble [aria-hidden="true"]') || link.querySelector('.cart-count-bubble');
    if (!s) return 0;
    var n = parseInt(s.textContent.replace(/[^\d]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  function initCart() {
    var link = doc.getElementById('cart-icon-bubble');
    if (!link) return;
    if (cartObserver) cartObserver.disconnect();
    // The theme names the link aria-label="Open cart", which hides the bubble's count from screen
    // readers (the label wins over the content). Keep the theme's words and add the count.
    var base = link.getAttribute('data-tic-label') || link.getAttribute('aria-label') || '';
    link.setAttribute('data-tic-label', base);
    var name = function (n) {
      if (base) link.setAttribute('aria-label', n > 0 ? base + ', ' + n + (n === 1 ? ' item' : ' items') : base);
    };
    var last = readCount(link);
    link.setAttribute('data-tic-count', String(last));
    name(last);
    cartObserver = new MutationObserver(function () {
      var n = readCount(link);
      if (n === last) return;
      var was = last;
      last = n;
      link.setAttribute('data-tic-count', String(n));
      name(n);
      if (n === 0) return;
      var bubble = link.querySelector('.cart-count-bubble');
      if (!bubble) return;
      var target = was === 0 ? bubble : (bubble.querySelector('[aria-hidden="true"]') || bubble);
      target.classList.remove('tic-count-in');
      void target.offsetWidth;
      target.classList.add('tic-count-in');
    });
    cartObserver.observe(link, { childList: true, subtree: true, characterData: true });
  }

  /* ------------------------------------------------------------------
     3. Letter-split header labels (runs before GTranslate walks the page: this file is deferred
        and comes before the app's script in the document)
     ------------------------------------------------------------------ */
  function initLabels() {
    Array.prototype.forEach.call(doc.querySelectorAll('.header__menu .list-menu--inline > li > .header__menu-item .header-link-animation .wrapper'), function (w) {
      if (w.querySelector('.char')) w.textContent = w.textContent;
    });
    // country/currency label, and the burger's "Menu" (Google renders it "Speisekarte" in German)
    Array.prototype.forEach.call(doc.querySelectorAll('.header__localization .localization-form__select, .header-top__burger_title'), function (b) {
      b.classList.add('notranslate');
      b.setAttribute('translate', 'no');
    });
  }

  /* ------------------------------------------------------------------
     4. Header fit (desktop, >= 1100px). Translated menus are up to 50% longer than the English one
        (de "EIN VORGESCHMACK AUF DEN SOMMER"): on the draft they pushed country, language and cart
        off-screen at 1440px in it/de/fr/es/nl/pt/el. tic-header.css pins the right block; here the
        header steps down only as far as the current text needs, re-checked on resize, font load and
        every change of the menu text (GTranslate rewrites it ~250ms after a switch):
          0  as designed
          1  tighter link spacing
          2  + country selector out of the row (still in the menu drawer and the footer)
          3  links behind the theme's own "Menu" button (the drawer lists them), country back
     ------------------------------------------------------------------ */
  var FIT_GAP = 24; // px between the last link and the right block
  var fitRoot = null;
  var fitNav = null;
  var fitMo = null;
  var fitQueued = false;
  var desktopMq = window.matchMedia ? window.matchMedia('(min-width: 1100px)') : null;

  function setFit(level) {
    if (level) fitRoot.setAttribute('data-tic-fit', String(level));
    else fitRoot.removeAttribute('data-tic-fit');
  }

  function menuFits() {
    var lis = fitNav.querySelectorAll('.list-menu--inline > li');
    var right = fitRoot.querySelector('.header-top__right');
    if (!lis.length || !right) return true;
    var end = 0;
    for (var i = 0; i < lis.length; i++) end = Math.max(end, lis[i].getBoundingClientRect().right);
    var start = Infinity;
    for (var j = 0; j < right.children.length; j++) {
      var r = right.children[j].getBoundingClientRect();
      if (r.width > 0) start = Math.min(start, r.left);
    }
    if (start === Infinity) start = right.getBoundingClientRect().left;
    return end + FIT_GAP <= start && right.getBoundingClientRect().right <= root.clientWidth + 1;
  }

  function fit() {
    fitQueued = false;
    if (!fitRoot || !doc.contains(fitRoot) || !fitNav) return;
    var level = 0;
    if (desktopMq && desktopMq.matches && getComputedStyle(fitRoot).direction !== 'rtl') {
      for (level = 0; level < 3; level++) {
        setFit(level);
        if (menuFits()) break;
      }
    }
    setFit(level);
  }

  function queueFit() {
    if (fitQueued || !fitRoot) return;
    fitQueued = true;
    requestAnimationFrame(fit);
  }

  function initFit() {
    fitRoot = doc.querySelector('.shopify-section-header');
    fitNav = fitRoot && fitRoot.querySelector('.header-top__left > .header__menu');
    if (fitMo) fitMo.disconnect();
    if (!fitNav) return;
    fitMo = new MutationObserver(queueFit);
    fitMo.observe(fitNav, { childList: true, subtree: true, characterData: true });
    fit();
  }

  window.addEventListener('resize', queueFit);
  window.addEventListener('load', queueFit);
  if (desktopMq) {
    if (desktopMq.addEventListener) desktopMq.addEventListener('change', queueFit);
    else if (desktopMq.addListener) desktopMq.addListener(queueFit);
  }
  if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(queueFit);
  new MutationObserver(queueFit).observe(root, { attributes: true, attributeFilter: ['lang'] });
  doc.addEventListener('shopify:section:load', initFit);

  function init() {
    initLabels();
    initLang();
    initCart();
    initFit();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
})();
